import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getMenuItemTagStyles = (_, { palette = {} }) => ({
  menuItemTag: {
    backgroundColor: '#D83B01',
    color: palette.white,
    borderRadius: 12,
    padding: '0 7px',
    border: `1px solid ${palette.white}`,
    fontSize: 12,
    fontWeight: 'normal',
    height: 18,
    width: 'max-content',
    lineHeight: '14px',
    boxShadow: `0 2px 5px ${palette.neutralTertiary}`,
  },
  blueTag: {
    backgroundColor: '#F0F6FB',
    color: '#323130',
  },
  mccRecommendationTag: {
    marginLeft: '-2px',
  },
});

export class MenuItemTag extends React.PureComponent {
  static defaultProps = {
    tagClass: '',
  };
  render() {
    const {
      classes,
      tagContent,
      tagClass,
      i18n,
    } = this.props;
    if (!tagContent) {
      return (null);
    }
    if (!isString(tagContent)) {
      let {
        text,
      } = tagContent;
      const {
        expDate,
      } = tagContent;
      const today = Date.now();
      if (today > expDate || !i18n || !text) {
        return (null);
      }
      text = i18n.getString(text);
      return (
        <div className={`${classes.menuItemTag} ${classes[tagClass] || ''} menu-item-tag`}>{text}</div>
      );
    }
    // we should provide i18n if we provide the tagContent string
    return (
      <div className={`${classes.menuItemTag} ${classes[tagClass] || ''} menu-item-tag`}>{i18n ? i18n.getString(tagContent) : tagContent}</div>
    );
  }
}

MenuItemTag.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  tagContent: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  tagClass: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
};

MenuItemTag.defaultProps = {
  i18n: null,
};

export const StyledMenuItemTag = withDefaultStyles(MenuItemTag, getMenuItemTagStyles);
